// Navbar.jsx
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import Logo from '../assets/logo.jpeg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  // Phone number
  const phoneNumber = "7023332099";

  // Handle navigation with smooth scroll
  const handleNavigation = (e, sectionId) => {
    e.preventDefault();
    setIsOpen(false);

    // If we're on the home page, just scroll to section
    if (location.pathname === "/") {
      const element = document.querySelector(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If we're on another page, navigate to home first, then scroll
      navigate("/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.querySelector(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    }
  };

  // Handle home navigation
  const handleHomeClick = (e) => {
    e.preventDefault();
    setIsOpen(false);
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  // Handle Book Now - Redirect to Call
  const handleBookNow = (e) => {
    e.preventDefault();
    setIsOpen(false);
    // Open phone dialer
    window.location.href = `tel:${phoneNumber}`;
  };

  // Check if we're on home page
  const isHomePage = location.pathname === "/";

  return (
    <nav className="navbar">
      <div className="nav-logo">
        <a href="/" onClick={handleHomeClick} className="nav-logo-link">
          <img src={Logo} alt="Atoz Events" className="nav-logo-img" />
          <span className="nav-logo-text">Atoz Events</span>
        </a>
      </div>

      <button className="nav-toggle" onClick={toggleMenu} aria-label="Toggle menu">
        <i className={`fas ${isOpen ? "fa-times" : "fa-bars"}`}></i>
      </button>

      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>
          <a 
            href="/" 
            onClick={handleHomeClick}
            className={isHomePage ? "active" : ""}
          >
            <i className="fas fa-home"></i> Home
          </a>
        </li>
        <li>
          <a 
            href="#about" 
            onClick={(e) => handleNavigation(e, "#about")}
          >
            <i className="fas fa-info-circle"></i> About
          </a>
        </li>
        <li>
          <a 
            href="#services" 
            onClick={(e) => handleNavigation(e, "#services")}
          >
            <i className="fas fa-concierge-bell"></i> Events
          </a>
        </li>
        <li>
          <a 
            href="#contact" 
            onClick={(e) => handleNavigation(e, "#contact")}
          >
            <i className="fas fa-phone-alt"></i> Contact
          </a>
        </li>
        <li>
          <a 
            href="tel:7023332099" 
            className="nav-book-btn"
            onClick={handleBookNow}
          >
            <i className="fas fa-calendar-check"></i> Book Now
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;